const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBasketBall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 128",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DC5819"
    },
    d: "M22.31,108.22c0,0,19.22,20.22,52.19,15.09c32.97-5.12,46.19-34.03,48.91-50.51 c3.46-20.99-6.13-35.42-6.64-36.21C116.39,36.01,22.31,108.22,22.31,108.22z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF6C32"
    },
    d: "M20.81,21.51C1.06,42.3-2.29,72.67,12.56,96.14c6.91,10.92,11.14,13.14,11.14,13.14 S56.01,130,92.32,98.59c31.1-26.9,24.51-61.93,24.51-61.93s-3.88-8.48-12.04-16.53C86.68,2.25,46.2-5.23,20.81,21.51z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3130"
    },
    d: "M99.97,16.04c-0.29,0.02-29.18,2.1-59.74,43.18c-19.3,25.94-18.35,44.25-17.6,49.27 c0,0-1.47-1.21-2.51-2.33c-1.04-1.11-1.85-2.1-1.85-2.1c-0.08-8.79,2.55-25.45,18.76-47.23C61.7,23.64,85.29,14.99,95.18,12.75 c0,0,1.21,0.71,2.38,1.44C98.42,14.73,99.97,16.04,99.97,16.04z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3130"
    },
    d: "M15.57,27.78c3.21,5.27,10.96,16.66,24.38,28.55c16.89,14.98,34.45,27.16,52.17,36.19 c8.37,4.27,14.8,6.77,19.35,8.24c0,0-0.66,1.01-1.28,1.84c-0.62,0.83-1.3,1.53-1.3,1.53c-4.63-1.57-10.81-4.07-18.6-8.05 c-18.02-9.19-35.86-21.56-53-36.76C24.59,48.06,16.89,37.4,13.11,31.43c0,0,0.53-1.05,1.23-1.98S15.57,27.78,15.57,27.78z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3130"
    },
    d: "M53.18,4.77c-1.43,1.63-3.47,4.28-5.85,8.29c-2.18,3.66-3.3,7.3-4.6,11.52 C40.6,31.5,38.19,39.34,30.3,49.36C19.34,63.28,8.57,67.93,3.55,69.42c0,0-0.14-1.3-0.19-2.21c-0.05-0.91-0.03-1.94-0.03-1.94 c4.77-1.63,14.21-6.19,23.82-18.38c7.43-9.44,9.72-16.9,11.75-23.48c1.32-4.28,2.56-8.32,4.99-12.39c1.15-1.93,2.23-3.58,3.22-4.96 c0,0,1.11-0.37,2.63-0.71C50.92,5.07,53.18,4.77,53.18,4.77z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3130"
    },
    d: "M68.72,124.01c-3.35-3.03-10.27-9.95-15.32-19.58c-5.59-10.65-8.21-26.67-0.75-36.68 c8.52-11.42,24.43-12.97,38.89-12.97c0.02,0,0.04,0,0.06,0c18.41,0.01,32.26,3.86,32.42,3.91c0,0-0.11-1.35-0.26-2.5 c-0.13-0.99-0.27-1.91-0.27-1.91c-0.7-0.18-12.94-3.49-31.89-3.5c-0.02,0-0.04,0-0.06,0c-15.45,0-32.53,1.74-42.1,14.58 c-6.16,8.26-8.42,24.12,0.42,40.93c4.16,7.92,9.4,14.03,13.23,17.88c0,0,1.12,0.04,2.55,0.02 C67.05,124.17,68.72,124.01,68.72,124.01z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketBall);
export default __webpack_public_path__ + "static/media/BasketBall.248d45ec0866408850dd2036f6d40335.svg";
export { ForwardRef as ReactComponent };